import { useState } from "react";

export default function Section08({
  isMobile,
  openModal,
}: {
  isMobile: boolean;
  openModal: () => void;
}) {
  const [affiliationChecks, setAffiliationChecks] = useState<number[]>([]);
  const [timeChecks, setTimeChecks] = useState<number[]>([]);
  const [privacyCheck, setPrivacyCheck] = useState<boolean>(false);

  // Input states 추가
  const [name, setName] = useState<string>("");
  const [contact, setContact] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [content, setContent] = useState<string>("");
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const affiliationOptions = ["병원", "약국", "기업", "기타"];
  const timeOptions = ["오전", "오후"];

  const toggleAffiliationCheck = (index: number) => {
    setAffiliationChecks((prev) => {
      if (prev.includes(index)) {
        return prev.filter((item) => item !== index);
      } else {
        return [...prev, index];
      }
    });
  };

  const toggleTimeCheck = (index: number) => {
    setTimeChecks((prev) => {
      if (prev.includes(index)) {
        return prev.filter((item) => item !== index);
      } else {
        return [...prev, index];
      }
    });
  };

  const togglePrivacyCheck = () => {
    setPrivacyCheck((prev) => !prev);
  };

  // 폼 검증 함수
  const isFormValid = () => {
    return (
      affiliationChecks.length > 0 &&
      timeChecks.length > 0 &&
      name.trim() !== "" &&
      contact.trim() !== "" &&
      email.trim() !== "" &&
      content.trim() !== "" &&
      privacyCheck
    );
  };

  // API 호출 함수
  const submitForm = async () => {
    if (!isFormValid()) {
      alert("모든 필수 항목을 입력하고 동의해주세요.");
      return;
    }

    setIsSubmitting(true);

    try {
      const selectedAffiliations = affiliationChecks
        .map((index) => affiliationOptions[index])
        .join(", ");
      const selectedTimes = timeChecks
        .map((index) => timeOptions[index])
        .join(", ");

      const requestData = {
        type: selectedAffiliations,
        availableContactTime: selectedTimes,
        name: name,
        contact: contact,
        content: `${content}\n\n이메일: ${email}`,
      };

      const response = await fetch(
        "https://nimda.healthier.kr/admin/landing/inquiry",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        }
      );

      if (response.ok) {
        alert("문의가 성공적으로 제출되었습니다.");
        // 폼 초기화
        setAffiliationChecks([]);
        setTimeChecks([]);
        setName("");
        setContact("");
        setEmail("");
        setContent("");
        setPrivacyCheck(false);
      } else {
        throw new Error("서버 응답 오류");
      }
    } catch (error) {
      console.error("제출 오류:", error);
      alert("제출 중 오류가 발생했습니다. 다시 시도해주세요.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="w-full flex flex-col items-center bg-[#464861] desktop:py-[30px] desktop:px-[20px] py-[24px] px-[20px]">
      <div className="desktop:w-[960px] w-[342px] flex desktop:flex-row desktop:items-center items-start justify-between flex-col relative desktop:gap-[0px] gap-[16px]">
        <div
          className="font-pre-semibold text-[#FFFFFF] dekstop:text-[20px] text-[16px] leading-[140%] whitespace-pre-line"
          style={{ letterSpacing: "-0.3px" }}
        >
          헬시어 도입을 고민하고 있는 {"\n"}의사 선생님이시라면?
        </div>

        <div
          id="button"
          className="w-max flex items-center justify-center desktop:py-[16px] desktop:px-[24px] py-[8px] px-[14px] desktop:rounded-[12px] rounded-[8px] bg-[#696986] cursor-pointer"
          onClick={openModal}
        >
          <div
            className="font-pre-semibold text-[#FFFFFF] dekstop:text-[16px] text-[14px] leading-[140%] whitespace-pre-line"
            style={{ letterSpacing: "-0.3px" }}
          >
            서비스 도입 문의
          </div>
        </div>
      </div>
    </div>
  );
}
